import React from "react";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import Subsribe from "../../components/newsletter/Subsribe";
import PageHeader from "../../components/team/PageHeader";

export default function ContactUs({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader HeaderTitle="Contact Us" Parent="Contact Us" />
      <Contact information={information} bgColor="gray-light-bg" />
      {/* <Subsribe /> */}
      <Footer space information={information} />
    </Layout>
  );
}
